import Axios, { AxiosRequestConfig, AxiosRequestHeaders } from "axios";

import store from "../lib/createStore";
import { API_KEY, BASE_API_URL, API_BASE_URL } from "../config";

interface AdaptAxiosRequestConfig extends AxiosRequestConfig {
  headers: AxiosRequestHeaders;
}

function isValidStreamJoinUrl(url: string) {
  const regex = /(^|[^/])v2\/stream\/join\/[^/]+$/;
  return regex.test(url);
}

function authRequestInterceptor(config: AdaptAxiosRequestConfig) {
  // const state: GlobalState = store.getState();
  // const token = state?.application?.auth?.jwt;
  // if (token) {
  //   config.headers!.authorization = `Bearer ${token}`;
  // }

  if (config.url && (config.url.includes("authentication/referrer/validate") || isValidStreamJoinUrl(config.url))) {
    const referrer_token = localStorage.getItem('referrer_token')
    config.headers['X-Referrer-Token'] = referrer_token;
  }
  
  const token = localStorage.getItem('jwt_token')
  config.headers['X-Api-Key'] = API_KEY;
  config.headers['X-Auth-Token'] = token;
  config.headers.Accept = "application/json";
  return config;
}


const axios = Axios.create({
  baseURL: BASE_API_URL,
});

// axios.defaults.baseURL = 'https://1hedxmdsmd.execute-api.us-east-1.amazonaws.com/staging/';

axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const message = error.response?.data?.message || error.message;
    // useNotificationStore.getState().addNotification({
    //   type: 'error',
    //   title: 'Error',
    //   message,
    // });
    return Promise.reject(error);
  }
);

const axiosV2 = Axios.create({
  baseURL: API_BASE_URL,
});
axiosV2.interceptors.request.use(authRequestInterceptor);
axiosV2.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export { axios, axiosV2 };
